import React from "react";
//import { useHistory, Link, NavLink } from "react-router-dom";

import { AttributeContextProvider } from "../../../../Components/GMS/Attribute/AttributeContext";
import AttributeManage from "../../../../Components/GMS/Attribute/Manage";

function Attribute(props) {
  return (
    <React.Fragment>
      <AttributeContextProvider>
        <AttributeManage props={props} />
      </AttributeContextProvider>
    </React.Fragment>
  );
}

export default Attribute;
